module.exports = __webpack_public_path__ + "img/quotes.201013de.png";